import * as React from "react";
import cx from "classnames";
import { I18n } from "react-redux-i18n";

import { formatDate } from "@common/utils/date";
import { Flex } from "@common/components/Flex";
import { Loading } from "@common/components/loading";

import { InviteHistoryDto } from "@common/dto/invite-history/list-dto";
import { generateId } from "@common/utils/common";

import "./history-log.styles.scss";

export type HistoryLogProps = {
  className?: string;
  data: Array<InviteHistoryDto>;
  authorFullName: string;
  loading: boolean;
};

export const HistoryLog: React.FC<HistoryLogProps> = (props) => {
  const { authorFullName, data, loading, className } = props;

  const customItemUniqProperty = "customItemUniqProperty";

  const processedData = React.useMemo(() => {
    return data.map((history) => ({
      ...history,
      [customItemUniqProperty]: generateId(),
    }));
  }, [data]);

  return (
    <div className={cx("InviteStatusRelativeInviteHistoryLog", className)}>
      <h6 className="InviteStatusRelativeInviteHistoryLog__title">{I18n.t("History Log")}</h6>
      <p className="InviteStatusRelativeInviteHistoryLog__name">{authorFullName}</p>
      <div className="InviteStatusRelativeInviteHistoryLog__table">
        <Flex className="InviteStatusRelativeInviteHistoryLog__table__header">
          <h6 style={{ width: `50%` }} className="InviteStatusRelativeInviteHistoryLog__table__header__item">
            {I18n.t("Date")}
          </h6>
          <h6 style={{ width: `50%` }} className="InviteStatusRelativeInviteHistoryLog__table__header__item">
            {I18n.t("Status")}
          </h6>
        </Flex>
        {loading && <Loading size={20} margin="20px" />}
        {!loading && !processedData.length && (
          <div className="InviteStatusRelativeInviteHistoryLog__table__no-data-message">
            {I18n.t("No history logs")}
          </div>
        )}
        {!loading && processedData.length > 0 && (
          <div className="InviteStatusRelativeInviteHistoryLog__table__list">
            {processedData.map((row) => (
              <Flex
                key={row[customItemUniqProperty]}
                className="InviteStatusRelativeInviteHistoryLog__table__list__row"
              >
                <div style={{ width: `50%` }} className="InviteStatusRelativeInviteHistoryLog__table__list__row__item">
                  {formatDate(row.logEntryDate, { format: "YYYY-MM-DD HH:mm" })}
                </div>
                <div style={{ width: `50%` }} className="InviteStatusRelativeInviteHistoryLog__table__list__row__item">
                  {row.historyText}
                </div>
              </Flex>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
